import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, Heart } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export function Footer() {
  const { settings } = useAuth();
  const social = settings?.social || {};
  return (
    <footer className="bg-burgundy-dark border-t border-gold/25 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3 items-start">
          <div className="flex flex-col items-center md:items-start gap-4">
            <Logo />
            <p className="font-script text-gold text-2xl">Pop Into Happiness</p>
            <p className="text-cream/60 text-sm text-center md:text-left">
              Handcrafted gourmet snacks made with love. Something delicious for everyone.
            </p>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-serif text-gold text-lg mb-4">Explore</h4>
            <div className="flex flex-col gap-2 text-cream/75 text-sm">
              <Link to="/popcorn" className="hover:text-gold">Gourmet Popcorn</Link>
              <Link to="/cookies" className="hover:text-gold">Gourmet Cookies</Link>
              <Link to="/cinnamon-pecans" className="hover:text-gold">Cinnamon Pecans</Link>
              <Link to="/track" className="hover:text-gold">Track Your Order</Link>
              <Link to="/about" className="hover:text-gold">About Us</Link>
            </div>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-serif text-gold text-lg mb-4">Connect</h4>
            <p className="text-cream/75 text-sm mb-3">{settings?.email}</p>
            {settings?.phone && <p className="text-cream/75 text-sm mb-3">{settings.phone}</p>}
            <div className="flex gap-4 justify-center md:justify-start text-gold">
              {social.instagram && (
                <a href={`https://instagram.com/${social.instagram.replace("@", "")}`} target="_blank" rel="noreferrer" className="hover:text-gold-bright" data-testid="social-instagram">
                  <Instagram size={22} />
                </a>
              )}
              {social.facebook && (
                <a href={`https://facebook.com/${social.facebook}`} target="_blank" rel="noreferrer" className="hover:text-gold-bright" data-testid="social-facebook">
                  <Facebook size={22} />
                </a>
              )}
              {social.tiktok && (
                <a href={`https://tiktok.com/${social.tiktok}`} target="_blank" rel="noreferrer" className="hover:text-gold-bright" data-testid="social-tiktok">
                  <Music2 size={22} />
                </a>
              )}
            </div>
            <p className="text-cream/40 text-xs mt-4">{social.instagram}</p>
          </div>
        </div>

        <div className="border-t border-gold/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-cream/40 text-xs">© {new Date().getFullYear()} Overflow Popcorn Co. All rights reserved.</p>
          <p className="text-cream/40 text-xs flex items-center gap-1">
            Made with <Heart size={12} className="text-gold fill-gold" /> in the South
          </p>
          <Link to="/admin/login" className="text-cream/30 text-xs hover:text-gold" data-testid="footer-admin-link">
            Owner Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
